import React from 'react';

import Certifications from './Certifications';

const index = () => {
    return (
    	<>
      		<Certifications />
		</>
  	);
};

export default index;
